const router = [
    {
        path: '/store/detail',
        component: () => import( '../views/Store/Detail.vue'),
        beforeEnter(to, from, next) {
          document.title = '聊城房屋交易租赁平台';
          next()
        },
      },
      {
        path: '/store/list',
        component: () => import( '../views/Store/List.vue'),
        beforeEnter(to, from, next) {
          document.title = '聊城房屋交易租赁平台';
          next()
        },
      },
]
export default router
